import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ status }) {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState(status === "success" ? "polling" : "cancelled");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (status !== "success") return;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
        if (r.data.status === "expired") { setState("expired"); return; }
      } catch {}
      if (attempts >= 15) { setState("timeout"); return; }
      setAttempts(a => a + 1);
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [status, attempts]);

  return (
    <div className="max-w-md mx-auto p-8">
      <Card><CardContent className="p-8 text-center">
        {state === "polling" && (<>
          <Loader2 size={48} className="text-blue-500 animate-spin mx-auto mb-3"/>
          <h1 className="text-xl font-bold text-slate-900">Verificando pago…</h1>
          <p className="text-slate-500 text-sm mt-2">Un momento, estamos confirmando tu suscripción.</p>
        </>)}
        {state === "paid" && (<>
          <CheckCircle2 size={56} className="text-emerald-500 mx-auto mb-3"/>
          <h1 className="text-2xl font-bold text-slate-900">¡Suscripción activa!</h1>
          <p className="text-slate-600 text-sm mt-2">Tu cuenta Agendik Pro ya está activa.</p>
          <Button data-testid="go-dashboard-btn" onClick={() => nav("/doctor/panel")} className="mt-5 bg-blue-600 hover:bg-blue-700">Ir al panel</Button>
        </>)}
        {(state === "cancelled" || state === "error" || state === "expired" || state === "timeout") && (<>
          <XCircle size={56} className="text-red-500 mx-auto mb-3"/>
          <h1 className="text-2xl font-bold text-slate-900">Pago no completado</h1>
          <p className="text-slate-600 text-sm mt-2">Puedes intentar de nuevo cuando quieras.</p>
          <Button data-testid="back-dashboard-btn" onClick={() => nav("/doctor/panel")} className="mt-5 bg-slate-900 hover:bg-slate-800">Volver al panel</Button>
        </>)}
      </CardContent></Card>
    </div>
  );
}
